import { useState, useMemo } from 'react';

export function useTableSort(rows, initialKey = null, initialDir = 'asc') {
  const [sortKey, setSortKey] = useState(initialKey);
  const [sortDir, setSortDir] = useState(initialDir);

  const handleSort = (key) => {
    if (sortKey === key) {
      setSortDir(sortDir === 'asc' ? 'desc' : 'asc');
    } else {
      setSortKey(key);
      setSortDir('asc');
    }
  };

  const sortedRows = useMemo(() => {
    if (!sortKey || !Array.isArray(rows)) return rows;
    const dir = sortDir === 'asc' ? 1 : -1;
    return [...rows].sort((a, b) => {
      const av = resolveValue(a, sortKey);
      const bv = resolveValue(b, sortKey);
      if (av == null && bv == null) return 0;
      if (av == null) return 1;
      if (bv == null) return -1;
      if (typeof av === 'number' && typeof bv === 'number') return (av - bv) * dir;
      const as = String(av).toLowerCase();
      const bs = String(bv).toLowerCase();
      if (as < bs) return -1 * dir;
      if (as > bs) return 1 * dir;
      return 0;
    });
  }, [rows, sortKey, sortDir]);

  return { sortedRows, sortKey, sortDir, handleSort };
}

function resolveValue(row, key) {
  if (typeof key === 'function') return key(row);
  if (!key.includes('.')) return row[key];
  return key.split('.').reduce((acc, part) => (acc == null ? acc : acc[part]), row);
}

export function sortArrow(key, currentKey, currentDir) {
  if (key !== currentKey) return '';
  return currentDir === 'asc' ? ' ▲' : ' ▼';
}
